import { useQuery, UseQueryOptions } from "@tanstack/react-query";
import axios from "axios";
import { IBookingAttachment, ReactQueryKey } from "../../types";

type IGetBookingAttachmentsReturn = IBookingAttachment[]

export const getBookingAttachments = async (bookingId: string): Promise<IGetBookingAttachmentsReturn> => {
    const response = await axios.get(`/booking/${bookingId}/attachments`);
    return response.data;
};

export const useBookingAttachmentsQuery = (bookingId?: string, options?: UseQueryOptions<IGetBookingAttachmentsReturn | null>) => {
    return useQuery<IGetBookingAttachmentsReturn | null>(
        [ReactQueryKey.BookingAttachments, bookingId],
        () => {
            if (bookingId) {
                return getBookingAttachments(bookingId);
            }
            return null;
        },
        options
    )
};

export default getBookingAttachments;